import { render, staticRenderFns } from "./WorkforcePlanning.vue?vue&type=template&id=1948bce8&scoped=true"
import script from "./WorkforcePlanning.vue?vue&type=script&lang=js"
export * from "./WorkforcePlanning.vue?vue&type=script&lang=js"
import style0 from "./WorkforcePlanning.vue?vue&type=style&index=0&id=1948bce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948bce8",
  null
  
)

export default component.exports